import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"margin-top":"80px"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Промаркируйте все вещи ")
const _hoisted_3 = { style: {"display":"flex","gap":"20px","align-items":"flex-start","max-width":"350px","justify-content":"space-between","width":"100%"} }
const _hoisted_4 = { style: {"display":"flex","gap":"20px"} }
const _hoisted_5 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_6 = { style: {"font-size":"20px"} }
const _hoisted_7 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Распечатать")
const _hoisted_9 = ["id"]
const _hoisted_10 = ["id"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Получить имя ячейки")
const _hoisted_12 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_check = _resolveComponent("check")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_ctx.variations?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", null, [
          _hoisted_2,
          (_ctx.isAllMarked)
            ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                size: "40px",
                color: "green"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_check)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variations, (el, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: idx,
            style: {"display":"flex","padding-bottom":"20px","border-bottom":"1px solid #dbdde1","margin-bottom":"20px"}
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(idx + 1) + " ", 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, _toDisplayString(el.sizeType.name) + " " + _toDisplayString(el.sizeValue.name) + " - " + _toDisplayString(el.originalQuantity) + " шт. ", 1),
                  _createElementVNode("div", _hoisted_6, "Артикул: " + _toDisplayString(el.id), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_button, {
                  disabled: el.checked,
                  onClick: ($event: any) => (_ctx.printBarcode(el))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]),
                _createVNode(_component_el_checkbox, {
                  disabled: 
								!_ctx.isUserAllowedChange ||
								![_ctx.enumProductState.collected, _ctx.enumProductState.described].includes(_ctx.product.state)
							,
                  label: "Промаркировано",
                  modelValue: el.checked,
                  "onUpdate:modelValue": ($event: any) => ((el.checked) = $event),
                  checked: _ctx.enumVariationState.marked === el.state,
                  onChange: bool => _ctx.checkboxEvent(bool, el)
                }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "checked", "onChange"]),
                _createElementVNode("div", {
                  id: 'print_' + el.id,
                  class: "print-variation"
                }, [
                  _createElementVNode("img", {
                    id: 'barcode_' + el.id
                  }, null, 8, _hoisted_10),
                  _createElementVNode("div", null, _toDisplayString(el.id), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProductTag(el), (row, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: JSON.stringify(row) + JSON.stringify(idx),
                      style: {"white-space":"nowrap","text-overflow":"ellipsis","overflow":"hidden"}
                    }, [
                      row
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(row), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ], 8, _hoisted_9)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (_ctx.checkCellName(el.id))
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (_ctx.cellNameArr && _ctx.cellNameArr[el.id])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cellNameArr[el.id], (cellName) => {
                        return (_openBlock(), _createElementBlock("span", { key: cellName }, [
                          _createTextVNode(_toDisplayString(cellName) + " ", 1),
                          _hoisted_13
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}